import { defineFcm } from '../shared/factory';

export const FCM_PAYPAL_MOBILE_DEFAULT = defineFcm('paypal_mobile_default').asBoolean().withDefault(false).toConfig({
	owner: 'squad-site-platform-payments',
	scope: 'corgi-front-end',
	context: 'Payment Forms',
	description: 'Sets Paypal as the default selected payment method for users on mobile',
});
